export default "__VITE_ASSET__e5a47e41__"